// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__lRohb","progress":"Pagination_progress__1TO2h"};